<template lang="html">
  <li class="teamMember">
    <h3>{{name}}</h3>
    <p>{{job}}</p>
    <div class="teamMember__image" :style="{backgroundImage: `url(${image})`}"></div>
  </li>
</template>

<script>
export default {
  name: 'TeamMember',
  props: ['name', 'job', 'image']
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.teamMember {
  h3 {
    font-family: CamptonBold;
    font-size: 40px;
    line-height: 0.95;
    color: var(--Neu01);
    margin-bottom: 10px;
  }
  p {
    font-family: CamptonBook;
    font-size: 16px;
    line-height: 1.13;
    color: var(--M01);
  }
  &__image {
    position: absolute;
    pointer-events: none;
    border-radius: 50%;
    overflow: hidden;
    width: 320px;
    height: 320px;
    opacity: 0;
    left: 50%;
    top: 50%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    transform: translate3d(-50%, -50%, 0) scale(.5);
    transition: all .4s cubic-bezier(.4,.15,.4,1.3);
    will-change: transform;
    transform-origin: center;
  }
  &:hover {
    .teamMember__image {
      opacity: 1;
      transform: translate3d(-50%, -50%, 0) scale(1);
      z-index: 1;
    }
  }
  @include mq(0, 768px) {
    &__image {
      width: 260px;
      height: 260px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TeamMember.vue